import styled from 'styled-components';

export const Container = styled.div(() => ({
  display: 'grid',
  gap: '10rem',
}));

export const TaxStatement = styled.p(({ theme }) => ({
  margin: 0,
  fontSize: theme.typography.size14,
}));
